import {
    CHANGE_EXPIRE_IN,
    CHANGE_ID,
    CHANGE_IS_CHECKED,
    CHANGE_PASSWORD,
    CHANGE_DATA,
    CHANGE_USER,
    IS_LOGIN
} from '../actions/actionsAdmin';

const initialState = {
    isLogin: false,
    isChecked: false,
    id: "",
    password: "",
    user: "",
    expireIn: undefined,
    lastRequest: undefined
};

export function reducerAdminProtectora(state = initialState, action) {

    switch (action.type) {
        case IS_LOGIN:
            return {...state, isLogin: action.payload.isLogin};
        case CHANGE_ID:
            return {...state, id: action.payload.id};
        case CHANGE_PASSWORD:
            return {...state, password: action.payload.password};
        case CHANGE_DATA:
            return {...state, data: action.payload.data};
        case CHANGE_USER:
            return {...state, user: action.payload.user};
        case CHANGE_EXPIRE_IN:
            return {...state, expireIn: action.payload.expireIn};
        case CHANGE_IS_CHECKED:
            return {...state, isChecked: action.payload.isChecked};
        default:
            return state
    }
}